export enum CartItemType {
    NORMAL = 'NORMAL',
    PREORDER = 'PREORDER',
}

export enum PaymentMethodSimple {
    AUTO = 'AUTO',
    WALLET = 'WALLET',
}
